module.exports = __webpack_public_path__ + "img/d-navio-petroleo-gas.bba8e14c.png";